import TextField from "@material-ui/core/TextField";
import MenuItem from '@material-ui/core/MenuItem';
import useContext from "../../../context";
import { getQuotableResorts } from "../../../loanConfig";

export default function ResortSelect() {
  const [context, updateContext] = useContext();
  const resorts = getQuotableResorts(context.config.resorts, context.contractType);
  const selectedResort = resorts.some(({ name }) => name === context.resort) ? context.resort : '';

  return (
    <div className="quoteform__input">
      <TextField
        id="quote-tool-resort"
        select
        fullWidth
        label={context.config.loading ? 'Loading resorts…' : 'Resort'}
        disabled={!resorts.length}
        InputLabelProps={{
          shrink: Boolean(selectedResort)
        }}
        defaultValue=""
        value={selectedResort}
        onChange={({ target: { value } }) => updateContext((ctx) => {
          if (ctx.resort !== value) {
            ctx.termSelected = false;
          }
          ctx.resort = value;

          return ctx;
        })}
        variant="outlined"
      >
        {resorts.map(({ name, code }) => {
          return (
            <MenuItem key={code} value={name}>{name}</MenuItem>
          );
        })}
      </TextField>
    </div>
);
}



// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanOptions/components/ResortSelect.js